<template>
  <el-card class="ik-chart-card" :style="{ width: '100%', height: '100%' }">
    <div slot="header" class="clearfix">
      <span class="ik-chart-card-title">{{ title }}</span>
      <p class="table_title_img" />
      <span class="logo" />
    </div>
    <div
      :id="code"
      ref="chartDom"
      class="ik-chart-card-chart"
      :style="'height: ' + height + ''"
      @click="changeSize"
    />
  </el-card>
</template>

<script>
import { dimensionExtraction, initSingleSeries } from "@/views/frame/board/components/ik/echarts/dataProcess"
import theme from "@/views/frame/board/components/ik/echarts/theme/ik.json"
import * as echarts from "echarts"

export default {
  name: "IkPieBaseChart",
  props: {
    title: {
      type: String,
      default: "标题"
    },
    code: {
      type: String,
      default: "bar.base"
    },
    data: {
      type: Array,
      default: function() {
        return [
          { type: "类型1", dep: "部门1", value: "30" },
          { type: "类型1", dep: "部门2", value: "30" },
          { type: "类型1", dep: "部门1", value: "30" },
          { type: "类型4", dep: "部门2", value: "30" },
          { type: "类型4", dep: "部门1", value: "35" },
          { type: "类型4", dep: "部门2", value: "37" },
          { type: "类型6", dep: "部门1", value: "30" },
          { type: "类型6", dep: "部门2", value: "35" },
          { type: "类型6", dep: "部门1", value: "39" },
          { type: "类型7", dep: "部门1", value: "39" }
        ]
      }
    },
    // 数据分析维度 - 第一数据维度
    dataDimensionField: {
      type: String,
      default: "value"
    },
    dataDimensionMin: {
      type: String,
      default: ""
    },
    dataDimensionMax: {
      type: String,
      default: ""
    },
    dataDimensionInterval: {
      type: String,
      default: ""
    },
    dataDimensionUom: {
      type: String,
      default: ""
    },
    gridType: {
      type: String,
      default: "summary"
    },
    // 数据分析维度 - 第一分析维度 - 横坐标
    analysisDimensionField: {
      type: String,
      default: "type"
    },
    analysisDimension: {
      type: Array,
      default: function() {
        return []
      }
    },
    // 数据分析维度 - 第二分析维度 - 图例
    secondAnalysisDimensionField: {
      type: String,
      default: ""
    },
    secondAnalysisDimension: {
      type: Array,
      default: function() {
        return []
      }
    },
    // 样式
    height: {
      type: String,
      default: "100%"
    }
  },
  data() {
    return {
      chartAnalysisDimension: [],
      chartSeries: [],
      chartDom: null,
      chart: null
    }
  },
  watch: {
    data() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    changeSize() {
      // 修改 echart 大小
      this.chart.resize()
    },
    init() {
      const $this = this
      // 初始化 chart 样式
      // 基于准备好的dom，初始化echarts实例
      const dom = document.getElementById($this.code)
      echarts.registerTheme("ik", theme)
      this.chart = echarts.init(dom, "ik")
      // 如果第一维度不存在，通过字段抽取
      if ($this.analysisDimension.length === 0) {
        // 第一维度必需
        if ($this.analysisDimensionField === "") {
          console.log("First Analysis Dimension Field Is Null")
        }
        $this.chartAnalysisDimension = dimensionExtraction(
          $this.data,
          $this.analysisDimensionField
        )
      } else {
        $this.chartAnalysisDimension = $this.analysisDimension
      }

      // 生成 series
      const series = initSingleSeries(
        $this.data,
        $this.chartAnalysisDimension,
        [],

        $this.analysisDimensionField,
        "",
        $this.dataDimensionField,
        $this.gridType
      )

      // 生成数据轴数据
      const axis = {}
      if ($this.dataDimensionMin !== "") {
        axis["min"] = Number($this.dataDimensionMin)
      }
      if ($this.dataDimensionMax !== "") {
        axis["max"] = Number($this.dataDimensionMax)
      }
      if ($this.dataDimensionInterval !== "") {
        axis["interval"] = Number($this.dataDimensionInterval)
      }
      if ($this.dataDimensionUom !== "") {
        console.log()
      }

      //
      const chartSeriesData = []
      for (const key in series["数据"]) {
        chartSeriesData.push({
          name: $this.chartAnalysisDimension[key],
          value: series["数据"][key]
        })
      }
      const chartSeries = {
        name: "数据",
        type: "pie",
        data: chartSeriesData
      }
      // 绘制图表
      this.chart.setOption({
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "right",
          data: $this.chartAnalysisDimension
        },
        series: chartSeries
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ik-chart-card {
  width: 100%;
  height: 100%;
  position: relative;
  ::v-deep .el-card__header {
    padding: 10px;
    position: absolute;
    width: 100%;
    // height: 20%!important;
    .clearfix {
      height: 20px;
      line-height: 20px;
    }
  }
  ::v-deep .el-card__body {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: calc(100% - 41px) !important;
    padding: 0px;
    padding-left: 5px;
    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
// @import './default.scss';
// @import '../../../../../../../styles/robot/robot.scss';
</style>
